import { ReactNode, useRef } from "react";
import useOutsideClick from "../../../hooks/useOutsideClick";
import "./dropdown_styles.css";

export type DropDownProps = {
    children?: ReactNode;
    top: number;
    left: number;
    closeFunction: () => void;
};

function DropDown(props: DropDownProps) {
    const divRef = useRef<HTMLDivElement>(null);
    const onOutsideClick = () => {
        props.closeFunction();
    };
    useOutsideClick(divRef, onOutsideClick);
    return (
        <div
            ref={divRef}
            className="dropdown-list-wrapper"
            style={{ left: props.left + "px", top: props.top + "px" }}
        >
            {props.children}
        </div>
    );
}

export default DropDown;
